import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemAwarenessSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-white overflow-hidden" data-id="element-405">
      <Container data-id="element-406">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-407">
          {/* Left Content */}
          <div className="order-2 lg:order-1" data-id="element-408">
            <div className="inline-flex items-center justify-center p-3 bg-red-50 rounded-full mb-8" data-id="element-409">
              <AlertTriangle className="w-6 h-6 text-red-600 mr-2" data-id="element-410" />
              <span className="text-red-800 font-bold uppercase tracking-wide text-sm" data-id="element-411">
                The Hidden Cost
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-8 leading-tight" data-id="element-412">
              Snoring Isn’t Just Noise… <br className="hidden md:block" data-id="element-413" />
              <span className="text-red-600 bg-red-50 px-2" data-id="element-414">It’s Damage</span>
            </h2>

            <div className="bg-gray-50 rounded-2xl p-8 mb-10 border border-gray-100 shadow-sm" data-id="element-415">
              <p className="text-xl font-bold text-gray-900 mb-6" data-id="element-416">
                Every night it happens:
              </p>

              <div className="space-y-4" data-id="element-417">
                {['Your partner lies awake angry', 'You wake up exhausted', 'The couch becomes normal', 'The fights start in the morning', 'The distance grows quietly'].map((pain, index) => <div key={index} className="flex items-center p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-red-200 transition-colors" data-id="element-418">
                    <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0" data-id="element-419" />
                    <span className="text-gray-800 font-semibold text-lg" data-id="element-420">
                      {pain}
                    </span>
                  </div>)}
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-421">
                <p className="text-xl text-gray-800 font-medium leading-relaxed" data-id="element-422">
                  Snoring isn’t harmless. <br data-id="element-423" />
                  <span className="font-bold text-red-600" data-id="element-424">
                    It’s slowly destroying sleep, intimacy, and your
                    relationship.
                  </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-425">
              <Button onClick={scrollToPricing} variant="secondary" size="xl" className="shadow-xl shadow-orange-500/20 px-10 py-4 text-lg w-full sm:w-auto" data-id="element-426">
                Fix It Tonight →
              </Button>
              <p className="text-sm text-gray-500 font-medium italic" data-id="element-427">
                Don't let another night ruin your day.
              </p>
            </div>
          </div>

          {/* Right Visuals */}
          <div className="order-1 lg:order-2 relative" data-id="element-428">
            {/* Main Image - Frustrated Couple */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500 z-10" data-id="element-429">
              <div className="absolute inset-0 bg-red-900/20 mix-blend-multiply z-10" data-id="element-430"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-431"></div>
              <img src="https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80" alt="Frustrated couple in bed" className="w-full h-[500px] object-cover" data-id="element-432" />
              <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-433">
                <div className="bg-white/90 backdrop-blur-sm p-4 rounded-xl border-l-4 border-red-500" data-id="element-434">
                  <p className="text-red-800 font-bold italic" data-id="element-435">
                    "I was ready to sleep in the guest room forever..."
                  </p>
                </div>
              </div>
            </div>

            {/* Secondary Image - Couch */}
            <div className="absolute -bottom-12 -left-12 w-64 h-48 rounded-2xl overflow-hidden shadow-xl border-4 border-white transform -rotate-3 hidden lg:block z-20" data-id="element-436">
              <img src="https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800&q=80" alt="Sleeping on couch" className="w-full h-full object-cover" data-id="element-437" />
              <div className="absolute inset-0 bg-black/30 flex items-center justify-center" data-id="element-438">
                <span className="text-white font-bold text-lg drop-shadow-md" data-id="element-439">
                  The "Dog House"
                </span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}